import { useStepperContext } from '@ahmdigital/ui';

const useActiveIndex = () => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'activeStep' does not exist on type '{}'.
  const { activeStep, steps } = useStepperContext();
  const activeIndex = steps.indexOf(activeStep);
  return activeIndex;
};

export default useActiveIndex;
